const actions = {
	GET_REORDER_PARAGRAPH: 'GET_REORDER_PARAGRAPH',
	GET_REORDER_PARAGRAPH_SUCCESS: 'GET_REORDER_PARAGRAPH_SUCCESS',

	CREATE_NEW_REORDER_PARAGRAPH: 'CREATE_NEW_REORDER_PARAGRAPH',
	CREATE_NEW_REORDER_PARAGRAPH_SUCCESS: 'CREATE_NEW_REORDER_PARAGRAPH_SUCCESS',

	DELETE_REORDER_PARAGRAPH: 'DELETE_REORDER_PARAGRAPH',
	DELETE_REORDER_PARAGRAPH_SUCCESS: 'DELETE_REORDER_PARAGRAPH_SUCCESS',

	GET_REORDER_PARAGRAPH_DETAIL: 'GET_REORDER_PARAGRAPH_DETAIL',
	GET_REORDER_PARAGRAPH_DETAIL_SUCCESS: 'GET_REORDER_PARAGRAPH_DETAIL_SUCCESS',

	UPDATE_REORDER_PARAGRAPH_DETAIL: 'UPDATE_REORDER_PARAGRAPH_DETAIL',
	UPDATE_REORDER_PARAGRAPH_DETAIL_SUCCESS: 'UPDATE_REORDER_PARAGRAPH_DETAIL_SUCCESS',

	READING_LOADING_FALSE: 'READING_LOADING_FALSE',
	//#region CRUD

	getReOrderParagraph: (model) => ({
		type: actions.GET_REORDER_PARAGRAPH,
		payload: { model },
	}),

	getReOrderParagraphDetail: (id) => ({
		type: actions.GET_REORDER_PARAGRAPH_DETAIL,
		payload: { id },
	}),

	// createQuesReadAloud: (body, cbSuccess, cbError) => ({
	// 	type: actions.CREATE_NEW_REORDER_PARAGRAPH,
	// 	payload: { body },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// getReadAloudDetail: (id) => ({
	// 	type: actions.GET_REORDER_PARAGRAPH_DETAIL,
	// 	payload: { id },
	// }),

	// updateReadAloudDetail: (model, cbSuccess, cbError) => ({
	// 	type: actions.UPDATE_REORDER_PARAGRAPH_DETAIL,
	// 	payload: { model },
	// 	cbSuccess,
	// 	cbError,
	// }),

	// deleteReadAloud: (id, cbSuccess, cbError) => ({
	// 	type: actions.DELETE_REORDER_PARAGRAPH,
	// 	payload: { id },
	// 	cbSuccess,
	// 	cbError,
	// }),
};

export default actions;
